import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pick, prop } from 'ramda';
import { getURLParams, getCleanUrl } from '@core/js/utils/url.util';
import { useAppSelector, usePageSelector } from '@core/js/store/hooks';

import { useTriggerCondition } from '@core/js/components/system/TagManager/components/Emitter';
import { getBasicCondition } from '@core/js/components/system/TagManager/helpers';
import { BASIC_TAG_LAUNCH_CONDITION } from '@core/js/components/system/TagManager/constants';

export const useTriggerBeforePageRendered = () => {
    const location = useLocation();
    const rootPage = useAppSelector(prop('rootPage'));
    const { isPageRendering, friendlyURL, path } = usePageSelector(pick(['isPageRendering', 'friendlyURL', 'path']));
    const triggerCondition = useTriggerCondition();
    let page = friendlyURL || rootPage || path && getCleanUrl(path);

    if (page === '/') {
        page = rootPage;
    }

    useEffect(() => {
        if (page && isPageRendering) {
            triggerCondition(getBasicCondition({
                launch: BASIC_TAG_LAUNCH_CONDITION.beforePageRendered,
                page,
                urlParams: getURLParams(location.search)
            }));
        }
    }, [isPageRendering, triggerCondition, page, location.search]);
};
